export default "__VITE_ASSET__B96A74eh__"